var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForwardQueue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.93,16.89l-.28-.54a9.88,9.88,0,0,0-1.48-2.45,1.18,1.18,0,0,0-1.39-.23,3.27,3.27,0,0,0-.7.59,2.41,2.41,0,0,1-1.51.5h-.49a2.32,2.32,0,0,1-1.54-.52,4.39,4.39,0,0,0-.71-.58,1.29,1.29,0,0,0-1.52.23,12.2,12.2,0,0,0-1.54,2.35v.07a1.64,1.64,0,0,1,1.6.45,12.46,12.46,0,0,1,.88,1.18h7.9a1.07,1.07,0,0,0,.88-.31A1,1,0,0,0,29.93,16.89Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.81,20.11l-.27-.55A9.66,9.66,0,0,0,20,17.13a1.15,1.15,0,0,0-1.38-.25,3.65,3.65,0,0,0-.71.59,2.37,2.37,0,0,1-1.54.5h-.49a2.42,2.42,0,0,1-1.56-.51,4.3,4.3,0,0,0-.69-.59,1.24,1.24,0,0,0-1.51.23,10.88,10.88,0,0,0-1.58,2.35l-.11.23a1.56,1.56,0,0,1,1.54.46,8.88,8.88,0,0,1,.76,1.06H21a1.15,1.15,0,0,0,.93-.32A1,1,0,0,0,21.81,20.11Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94,24.63A1.19,1.19,0,0,1,2,24.3c-.16-.21,0-.61,0-.85l.26-.55a11.22,11.22,0,0,1,1.54-2.41,1.28,1.28,0,0,1,1.51-.25,5,5,0,0,1,.7.59,2.42,2.42,0,0,0,1.5.52H8a2.31,2.31,0,0,0,1.54-.51,4,4,0,0,1,.71-.59,1.19,1.19,0,0,1,1.39.24A10.11,10.11,0,0,1,13.09,23l.27.54a1.05,1.05,0,0,1,.09.85,1.11,1.11,0,0,1-.93.3Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09,16.33a3.46,3.46,0,0,0,3.24-3.63v-.08a3.33,3.33,0,0,0-3.24-3.41H16a3.34,3.34,0,0,0-3.18,3.5v0A3.47,3.47,0,0,0,16.09,16.33Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78,19.67A3.45,3.45,0,0,0,11,16.06V16a3.32,3.32,0,0,0-3.22-3.41h0A3.31,3.31,0,0,0,4.61,16h0A3.53,3.53,0,0,0,7.78,19.67Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.24,13.12a3.47,3.47,0,0,0,3.29-3.63v0h0A3.33,3.33,0,0,0,24.32,6h-.08a3.32,3.32,0,0,0-3.19,3.44h0A3.46,3.46,0,0,0,24.24,13.12Z",
    style: {
      fill: "#00a6e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardQueue);
export default __webpack_public_path__ + "static/media/forward-queue.099af58b.svg";
export { ForwardRef as ReactComponent };